import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import styles from "src/Assets/css/home/Feed.module.css";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import "primeflex/primeflex.css";
import "src/Assets/css/Gobal.css";
import { useSelector } from "react-redux";
import AboutMap from "../FooterComponents/AboutMap";
import closeBtn from "src/Assets/images/CloseButton.svg";
import API from "../../network";

const location = {
  address: "4125 Blackford Avenue, Suite 255 San Jose, CA 95117",
  lat: 37.3229763,
  lng: -121.9763862,
};

function Contact(props) {
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const [isMessageText, setMessageText] = React.useState("");
  const [isEmail, setEmail] = React.useState("");
  const [isName, setName] = React.useState("");

  useEffect(() => {
    if (userDetails && Object.keys(userDetails).length !== 0) {
      setEmail(userDetails.userData.userEmail);
      setName(userDetails.userData.displayName);
    }
  }, [userDetails]);

  const onTextChangeHandler = (e, messageType) => {
    if (messageType === "Name") {
      setName(e.target.value);
    } else if (messageType === "Email") {
      setEmail(e.target.value);
    } else {
      setMessageText(e.target.value);
    }
  };

  const onSubmit = () => {
    API.postContact(`name=${isName}&email=${isEmail}&desc=${isMessageText}`)
      .then((res) => {
        setMessageText("");
        alert(
          "your message  has been sent  and you will receive a  response soon"
        );
        props.onHide();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <React.Fragment>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className={styles.contactModalbgcolor}>
          <Modal.Header>
            <div className={styles.ContactHeadingContainer}>
              <h5 className={styles.ContactHeading}>Contact</h5>
              <button
                type="button"
                onClick={props.onHide}
                className={styles.contactCloseBtn}
              >
                <img src={closeBtn} alt="close button" />
              </button>
            </div>
          </Modal.Header>

          <Modal.Body>
            {userDetails && Object.keys(userDetails).length !== 0 ? (
              <div className="p-fluid">
                <div className={`p-field ${styles.inputContainer}`}>
                  <label htmlFor="firstname1" className={styles.contactBoxName}>
                    Name:
                  </label>
                  <input
                    id="firstname1"
                    type="text"
                    value={isName}
                    className={styles.contactTextarea}
                    onChange={(e) => onTextChangeHandler(e, "Name")}
                  />
                </div>
                <div className={`p-field ${styles.inputContainer}`}>
                  <label htmlFor="lastname1" className={styles.contactBoxName}>
                    Email:
                  </label>
                  <input
                    id="lastname1"
                    type="email"
                    value={isEmail}
                    className={styles.contactTextarea}
                    onChange={(e) => onTextChangeHandler(e, "Email")}
                  />
                </div>
                <div className={`p-field ${styles.inputContainer}`}>
                  <label htmlFor="lastname1" className={styles.contactBoxName}>
                    Message:
                  </label>

                  <textarea
                    placeholder="Type your message"
                    rows="5"
                    value={isMessageText}
                    className={styles.contactTextarea}
                    onChange={(e) => onTextChangeHandler(e, "Message")}
                  />
                </div>
              </div>
            ) : (
              <div className="p-fluid">
                <div className={`p-field ${styles.inputContainer}`}>
                  <label htmlFor="firstname1" className={styles.contactBoxName}>
                    Name:
                  </label>
                  <input
                    required
                    maxlength="50"
                    size="10"
                    id="firstname1"
                    type="text"
                    className={styles.contactTextarea}
                    placeholder="Your name"
                    onChange={(e) => onTextChangeHandler(e, "Name")}
                  />
                </div>
                <div className={`p-field ${styles.inputContainer}`}>
                  <label htmlFor="lastname1" className={styles.contactBoxName}>
                    Email:
                  </label>
                  <input
                    id="lastname1"
                    type="email"
                    required
                    maxlength="50"
                    className={styles.contactTextarea}
                    placeholder="Your email"
                    onChange={(e) => onTextChangeHandler(e, "Email")}
                  />
                </div>
                <div className={`p-field ${styles.inputContainer}`}>
                  <label htmlFor="lastname1" className={styles.contactBoxName}>
                    Message:
                  </label>

                  <textarea
                    type="text"
                    required
                    minlength="4"
                    maxlength="280"
                    placeholder="Type your message"
                    rows="5"
                    className={styles.contactTextarea}
                    onChange={(e) => onTextChangeHandler(e, "Message")}
                  />
                </div>
              </div>
            )}
            <div className={styles.sendtoContact}>
              <button
                className={`${styles.contactSend} ${
                  isMessageText.length > 0 ? null : styles.contactSendButton
                }`}
                autoCapitalize="none"
                onClick={() => onSubmit()}
              >
                Send
              </button>
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
          <div className={styles.address}>
            <p>Address: </p>
            <AboutMap location={location} />
            {/* <p onClick={() => setModalShow(true)}> 4125 Blackford Avenue, San Jose, CA 97117</p> */}
          </div>
          <div className={styles.address}>
            <p>Telephone: </p>
            <p className={styles.addressContact}>
              {" "}
              +1 (408) 230-0123, +1 (408) 799-2103
            </p>
          </div>
          <span></span>
        </div>
      </Modal>
    </React.Fragment>
  );
}
function FooterComponent() {
  const history = useHistory();
  const [modalShow, setModalShow] = React.useState(false);

  const onModalSelect = () => {
    setModalShow(false);
  };

  const navigateTo = (pathname, state) => {
    if (history) {
      history.push(pathname, state);
    } else {
      window.location.href = pathname;
    }
  };

  return (
    <div className="footer-links">
      <span style={{ cursor: "pointer" }} onClick={() => navigateTo("/About", { footerType: "About" })}>
        About
      </span>
      <span> | </span>
      <span style={{ cursor: "pointer" }} onClick={() => navigateTo("/PrivacyPolicy", { footerType: "PrivacyPolicy" })}>
        Privacy
      </span>
      <span> | </span>
      <span style={{ cursor: "pointer" }} onClick={() => navigateTo("/TermsofService", { footerType: "TermsofService" })}>
        Terms
      </span>
      <span> | </span>
      <span style={{ cursor: "pointer" }} onClick={() => navigateTo("/Careers")}>
        Careers
      </span>
      <span> | </span>
      <a style={{ color: "#000000" }} onClick={() => setModalShow(true)}>
        Contact
      </a>
      <span> | </span>

      <span style={{ cursor: "pointer" }} onClick={() => navigateTo("/help")}>
        Help
      </span>
      <span> | </span>

      <span style={{ cursor: "pointer" }} onClick={() => navigateTo("/UserGuidelines", { footerType: "UserGuidelines" })}>
        User Guidelines
      </span>
      <span> | </span>

      <span style={{ cursor: "pointer" }} onClick={() => navigateTo("/cookies")}>
        Cookies
      </span>

      <span>{/* <p>Skopic &#169; 2021</p> */}</span>

      <Contact
        show={modalShow}
        onHide={() => onModalSelect()}
        modalShow={modalShow}
        setModalShow={setModalShow}
      />
    </div>
  );
}

export default FooterComponent;
